export default __webpack_public_path__ + "static/bsr-banner-c60005094a51be05ee99ae0f6401f944.jpg";